const INITIAL_STATE = {
  categories: [],
  widgets: [],
  announcement: null,
  detail: null,
  loading: false,
  detailLoading: false,
  categoryDetail: {},
  categoryDetailLoading: {},
  categoryArticles: {},
  categoryArticlesLoading: {},
};

const getWidgets = (categories) => {
  const widgets = [];
  categories.forEach(category => {
    const pos = category.widgetPosition;
    if (pos > 0) widgets[pos] = { ...category };
  });
  return widgets;
};

const getAnnouncement = (categories) => {
  const announcement = categories.find(category => category.isAnnouncement);
  if (announcement) return { ...announcement };
  return null;
};

export default (state = INITIAL_STATE, action) => {
  let categories;
  switch (action.type) {
    case 'GET_CATEGORIES_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'GET_CATEGORIES_SUCCESS':
      return {
        ...state,
        loading: false,
        categories: action.payload,
        widgets: getWidgets(action.payload),
        announcement: getAnnouncement(action.payload),
      };
    case 'GET_CATEGORIES_FAILURE':
      return {
        ...state,
        loading: false,
      };
    case 'GET_CATEGORY_REQUEST':
      return {
        ...state,
        detailLoading: true,
        detail: null,
        categoryDetailLoading: state.categoryDetailLoading ? {
          ...state.categoryDetailLoading,
          [action.payload.id]: true,
        } : {
          [action.payload.id]: true,
        },
      };
    case 'GET_CATEGORY_SUCCESS':
      return {
        ...state,
        detailLoading: false,
        detail: action.payload,
        categoryDetailLoading: {
          ...state.categoryDetailLoading,
          [action.payload._id]: false,
        },
        categoryDetail: state.categoryDetail ? {
          ...state.categoryDetail,
          [action.payload._id]: action.payload,
        } : {
          [action.payload._id]: action.payload,
        },
      };
    case 'GET_CATEGORY_FAILURE':
      return {
        ...state,
        detailLoading: false,
        categoryDetailLoading: {
          ...state.categoryDetailLoading,
          [action.payload.id]: false,
        },
        categoryDetail: state.categoryDetail ? {
          ...state.categoryDetail,
          [action.payload.id]: null,
        } : {
          [action.payload.id]: null,
        },
      };
    case 'GET_CATEGORY_ARTICLES_REQUEST':
      return {
        ...state,
        detail: {
          ...state.detail,
          articles: [],
          total: 0,
        },
        categoryArticlesLoading: state.categoryArticlesLoading ? {
          ...state.categoryArticlesLoading,
          [action.payload.category]: true,
        } : {
          [action.payload.category]: true,
        },
      };
    case 'GET_CATEGORY_ARTICLES_SUCCESS':
      return {
        ...state,
        detail: {
          ...state.detail,
          articles: action.payload.articles,
          total: action.payload.total,
        },
        categoryArticlesLoading: {
          ...state.categoryArticlesLoading,
          [action.payload.category]: false,
        },
        categoryArticles: state.categoryArticles ? {
          ...state.categoryArticles,
          [action.payload.category]: action.payload,
        } : {
          [action.payload.category]: action.payload,
        },
      };
    case 'GET_CATEGORY_ARTICLES_FAILURE':
      return {
        ...state,
        categoryArticlesLoading: {
          ...state.categoryArticlesLoading,
          [action.payload.category]: false,
        },
      };
    case 'CREATE_CATEGORY_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'CREATE_CATEGORY_SUCCESS':
      return {
        ...state,
        categories: [...state.categories, action.payload.data],
        loading: false,
      };
    case 'CREATE_CATEGORY_FAILURE':
      return {
        ...state,
        loading: false,
      };
    case 'EDIT_CATEGORY_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'EDIT_CATEGORY_SUCCESS':
      return {
        ...state,
        categories: [...state.categories.filter(category => category._id !== action.payload._id), action.payload.data],
        loading: false,
      };
    case 'EDIT_CATEGORY_FAILURE':
      return {
        ...state,
        loading: false,
      };
    case 'DELETE_CATEGORY_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'DELETE_CATEGORY_SUCCESS':
      return {
        ...state,
        categories: [...state.categories.filter(category => category._id !== action.payload._id)],
        loading: false,
      };
    case 'DELETE_CATEGORY_FAILURE':
      return {
        ...state,
        loading: false,
      };
    case 'CHANGE_WIDGET_POSITION_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'CHANGE_WIDGET_POSITION_SUCCESS':
      categories = state.categories.map(category => {
        if (category._id !== action.payload._id) {
          if (category.widgetPosition === action.payload.newPosition) {
            return { ...category, widgetPosition: 0 };
          }
          return category;
        }
        return action.payload.data;
      });
      return {
        ...state,
        categories,
        widgets: getWidgets(categories),
        announcement: getAnnouncement(categories),
        loading: false,
      };
    case 'CHANGE_WIDGET_POSITION_FAILURE':
      return {
        ...state,
        loading: false,
      };
    case 'CHANGE_ANNOUNCEMENT_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'CHANGE_ANNOUNCEMENT_SUCCESS':
      categories = state.categories.map(category => {
        if (category._id !== action.payload._id) {
          if (category.isAnnouncement) {
            return { ...category, isAnnouncement: false };
          }
          return category;
        }
        return action.payload.data;
      });
      return {
        ...state,
        categories,
        widgets: getWidgets(categories),
        announcement: getAnnouncement(categories),
        loading: false,
      };
    case 'CHANGE_ANNOUNCEMENT_FAILURE':
      return {
        ...state,
        loading: false,
      };
    case 'LOGOUT':
      return INITIAL_STATE;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/category.js